import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { getLegalDocumentUrl } from '@fr/constants';
import { LeadBanner } from '@travelata-libs/ui-shared';
import { useLeadForm, useHotelLeadBannerTracking } from '@entities/lead';
import { useState } from 'vuex-composition-helpers';
import { NAMESPACE } from '@ve/components/hotel/filters/common/store/hotelPageFiltersAdapterStore';
import { MapForFiltersState } from '@ve/components/hotel/filters/common/store/types';
import { usePortalAnchor } from '@shared/lib';

    interface HotelLeadBannerProps {
        mobile?: boolean;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelLeadBanner',
  props: {
    mobile: { type: Boolean, default: false }
  },
  emits: ["visible"],
  setup(__props: any, { emit }: { emit: ({(e: 'visible', value: boolean): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { mobile: boolean }



    

    const { grouppedfilteredProductsByDates } = useState<MapForFiltersState>(NAMESPACE, ['grouppedfilteredProductsByDates']);

    const {
        formRef,
        isSubmitted, 
        onSubmit, 
        model,
        loading,
    } = useLeadForm(props.mobile);

    const { resetAnchor, anchorPosition } = usePortalAnchor('lead-banner', formRef);

    const isVisible = computed(() => grouppedfilteredProductsByDates.value.length >= 3);

    const hotelTracking = useHotelLeadBannerTracking({ formRef, isSubmitted });

    const isAnchorPositionVisible = computed(() => {
        if (props.mobile) return !!anchorPosition.value;
        return true;
    })
    const subtitle = 'Эксперт подскажет, какой подойдёт именно вам';

    const title = computed(() => {
        const text = 'Выбираете номер?';
        if(props.mobile) {
            return `${text} ${subtitle}`;
        }
        return text;
    })

    watch(isVisible, (visible) => {
        if (props.mobile && !visible) {
            resetAnchor();
        }

        emit('visible', !!visible);
    });


return { __sfc: true,props, emit, grouppedfilteredProductsByDates, formRef, isSubmitted, onSubmit, model, loading, resetAnchor, anchorPosition, isVisible, hotelTracking, isAnchorPositionVisible, subtitle, title, getLegalDocumentUrl, LeadBanner }
}

})